/* eslint-disable */

const INITIAL_STATE = {
  currentCountry: {
    _id: undefined,
    name: ''
  },
  countries: [],
  error: { message: '', isVisible: false },
  loading: false,
  loadingForm: false,
  order: 'asc',
  orderBy: 'id',
  selected: [],
  page: 0,
  rowsPerPage: 10,
};

const countriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_COUNTRIES_START':
    return { ...state, loading: true }

  case 'GET_COUNTRIES_SUCCESS':
    return { ...state, countries: action.payload, loading: false }

  case 'GET_COUNTRIES_FAIL':
    return { ...state, loading: false }

  case 'GET_COUNTRY_START':
    return { ...state, loading: true }

  case 'GET_COUNTRY_SUCCESS':
    return { ...state, currentCountry: action.payload, loading: false }

  case 'GET_COUNTRY_FAIL':
    return { ...state, loading: false }


  default:
    return state
  }
}

export default countriesReducer



// WEBPACK FOOTER //
// ./src/reducers/countriesReducer.js